<template>
  <div
    tabindex="-1"
    class="fixed top-0 left-0 right-0 z-40 flex flex-col items-center justify-center h-screen p-6 overflow-x-hidden overflow-y-auto bg-black/50">
    <div
      class="relative flex flex-col justify-center w-full max-w-lg px-6 py-6 text-base bg-white rounded-lg shadow-md -top-20">
      <div class="flex">
        {{ $t('auth.forgotPasswordTitle') }}
        <button
          type="button"
          @click="$emit('closeModal')"
          class="absolute right-2.5 top-3 ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-gray-700 hover:bg-gray-200 hover:text-gray-900">
          <svg
            aria-hidden="true"
            class="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              cliprule="evenodd"></path>
          </svg>
          <span class="sr-only">Close popup</span>
        </button>
      </div>

      <div class="flex flex-col w-full gap-2 mt-2 bg-white rounded-lg">
        <div class="text-sm text-left">{{ $t('auth.forgotPasswordSubtitle') }}</div>
        <div>
          <label for="email" class="text-sm font-medium">E-mail</label>
          <BaseInput
            v-model="userEmail"
            type="email"
            color="light"
            class="my-1"
            :error="$v.userEmail.$invalid ? $v.userEmail.required.$message : ''">
          </BaseInput>
        </div>
        <div>
          <label for="username" class="text-sm font-medium capitalize">{{
            $t('auth.username')
          }}</label>
          <BaseInput
            v-model="username"
            type="text"
            color="light"
            class="my-1"
            :error="$v.username.required.$invalid ? $v.username.required.$message : ''">
          </BaseInput>
        </div>

        <BaseButton outline class="w-full mt-6 border-0 bg-cyan-light" @click="onSubmit">{{
          $t('auth.forgotPasswordAction')
        }}</BaseButton>
        <BaseButton outline class="w-full capitalize" @click="$emit('closeModal')">{{
          $t('common.actions.cancel')
        }}</BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import BaseButton from '../common/BaseButton.vue';
import BaseInput from '../common/BaseInput.vue';
import { resetPassword } from '@/services/api/auth';

import { useVuelidate } from '@vuelidate/core';
import { required, helpers, email } from '@vuelidate/validators';

const props = defineProps<{
  databaseName: string;
}>();

const username = ref('');

const userEmail = ref('');

const emit = defineEmits(['closeModal', 'submitted']);

//validation
const rules = computed(() => ({
  username: { required: helpers.withMessage('Username is required', required) },
  userEmail: {
    required: helpers.withMessage('Invalid email', required),
    email: helpers.withMessage('Invalid email', email),
  },
}));

const $v = useVuelidate(rules, { username, userEmail }, { $lazy: true });

async function onSubmit() {
  $v.value.$touch();
  if ($v.value.$invalid) return;
  const result = await resetPassword(userEmail.value, username.value, props.databaseName);
  emit('submitted', result);
}
</script>
